import { MagazineNode } from '@gql/graphql'
import { useTrans } from '../../../hooks'
import { magazineDateFormat } from '@utils/safe'
import { Button, Tag, WImage, WLink } from '@components/atoms'
import styles from './ArticoloCard.module.sass'

interface Props {
  news?: any // MagazineNode?
  className?: string
  onClick?: () => void
}

const ArticoloCard = (props: Props) => {
  const { className = '', news = undefined, onClick = undefined } = props

  const t = useTrans()
  const classNames = `${styles.root} ${className}`

  const getContent = () => (
    <>
      <div className={styles.imageBox}>
        <WImage
          src={news.imageUrl}
          maxWidth={335}
          maxHeight={295}
          alt={news?.imageAlt}
          title={news?.imageAlt}
          objectFit="cover"
        />
        {news.tag && <Tag label={news.tag} className={styles.tag} />}
        {news?.premio ? (
          <div className={styles.listingBrand}>
            <WImage maxWidth={81} maxHeight={47} src={news?.premio} alt={news?.imageAlt} />
          </div>
        ) : null}
      </div>
      <div className={styles.content}>
        {!!news.pubDate && <p className={styles.intro}>{magazineDateFormat(news.pubDate)}</p>}
        {!!news.title && <h2 className={styles.title}>{news.title}</h2>}
        {!!news.subtitle && (
          <div className={styles.description} dangerouslySetInnerHTML={{ __html: news.subtitle }} />
        )}
        {!!news.url && <Button label={t("Leggi l'articolo")} variant="ghost" />}
      </div>
    </>
  )

  return news ? (
    news.url ? (
      <WLink href={news?.url} className={classNames} ariaLabel={news.title} onClick={onClick}>
        {getContent()}
      </WLink>
    ) : (
      <div className={classNames}>{getContent()}</div>
    )
  ) : (
    <></>
  )
}

export default ArticoloCard
